import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Homepage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import CookiesPolicy from "./pages/CookiesPolicy";
import CookieBanner from "./components/universal/cookiesBanner";
import { NavProvider } from "./context/nav-context";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import ScrollToHash from "./components/universal/ScrooltoHash";
import { HelmetProvider } from "react-helmet-async";
import SchemaComponent from "./components/universal/schema-component";
const TRACKING_ID = "G-8GJJKN21E4"; // your Measurement ID
function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);
  return (
    <>
      <HelmetProvider>
        <SchemaComponent />
        <NavProvider>
          <Router>
            <ScrollToHash />
            <CookieBanner />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/cookies-policy" element={<CookiesPolicy />} />
            </Routes>
          </Router>
        </NavProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
